import apiPath from '@store/apiPath'

export default {
  /**
   * 경매 목록 조회
   * @method GET
   */
  FETCH_AUCTIONS: `${apiPath.AUCTION}/v1/items`,
}
